function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomOceanViewCoralSeaViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.734a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.734V4.07H4.133z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.757 8.676l3.187 2.675-1.124 1.34-3.186-2.675 1.123-1.34zM16.875 8.934h-1.75v-4.16h1.75v4.16zM20.616 5.603l1.585.74-1.757 3.771-1.586-.74 1.758-3.77zM23.18 12.69l-1.124-1.339 3.186-2.675 1.124 1.34-3.186 2.675zM20.132 26.351h-5.64v-1.75h5.64v1.75z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.253 13.322a5.953 5.953 0 011.69 3.377h6.411v1.75H3.645v-1.75h6.411a5.96 5.96 0 011.69-3.377A5.975 5.975 0 0116 11.56a5.97 5.97 0 014.253 1.762zm-7.27 1.237a4.227 4.227 0 00-1.158 2.14h8.35a4.233 4.233 0 00-1.16-2.14A4.233 4.233 0 0016 13.31c-1.14 0-2.21.444-3.016 1.25z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.887 21.098H12.612v-1.75h10.275v1.75zM9.242 23.726h9.14v-1.75h-9.14v1.75zM11.383 5.603l1.758 3.77-1.585.74-1.758-3.77 1.585-.74z",
    fill: props.color
  }));
}

export default SvgIconRoomOceanViewCoralSeaViewFilled;